import { RouteType } from "types/RouteType";
import InventoryAdjustmentsWorkflowStore from "./InventoryAdjustmentsWorkflowStore";

const InventoryAdjustmentsWorkflowRoute: RouteType = {
  name: "Inventory Adjustments Workflow",
  path: "/workflows/inventory-adjustments",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Inventory Adjustments",
      component: () => import("./InventoryAdjustmentsWorkflowHeader"),
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./InventoryAdjustmentsWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!(rootStore as any).inventoryAdjustmentsWorkflowStore) {
      (rootStore as any).inventoryAdjustmentsWorkflowStore =
        new InventoryAdjustmentsWorkflowStore(rootStore);
    }
    await (rootStore as any).inventoryAdjustmentsWorkflowStore.loadInitialData();
    return true;
  },
};

export default InventoryAdjustmentsWorkflowRoute;
